// Vvendor
import { ref } from 'vue';
import { defineStore } from 'pinia';
export const useApiSettings = defineStore('pc-api-settings', () => {
    const locale = ref(null);
    return {
        locale,
    };
}, {
    persist: true,
});
//# sourceMappingURL=module.js.map